const LowerCaseTrim = (str) => {
    if (typeof str !== 'string') {
      return str;
    }
    
    return str?.toLowerCase()?.trim();
  }

  export default LowerCaseTrim;